import { IExportService } from '@price-for-profit/micro-services';
import { CLIENT_ID } from 'shared/constants';

export interface DownloadPdfProps<T> {
  exportId: string;
  fileName?: string;
  orientation?: 'landscape' | 'portrait';
  data: T;
}

export interface IEventExportService {
  downloadPdf<T>(props: DownloadPdfProps<T>): Promise<void>;
}

export class EventExportService implements IEventExportService {
  constructor(private exportService: IExportService) { }
  async downloadPdf<T>({
    exportId,
    data,
    fileName = 'export',
    orientation = 'portrait'
  }: DownloadPdfProps<T>): Promise<void> {
    const blob = await this.exportService.downloadPdf<T>({
      clientId: CLIENT_ID,
      templateId: exportId,
      payload: { orientation, data },
    });

    const blobUrl = URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    link.parentNode?.removeChild(link);
  }
}
